import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "component" }

import _ from 'lodash';
  import { useAttrs } from 'vue';
  import allComponents, { IComponent } from './components';

  export interface IProps {
    components: IComponent[];
    onToggleShowController?: Function;
    onChange?: Function;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    components: null,
    onToggleShowController: { type: Function, default: _.noop },
    onChange: { type: Function, default: _.noop }
  },
  setup(__props: any) {

  
  const attrs = useAttrs();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.components, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass({ container: item.hasContainer })
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_unref(allComponents)[item.name])
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(allComponents)[item.name].component), {
                key: 0,
                "model-value": __props.components[index].showController,
                props: item.props,
                "inject-data": _unref(attrs),
                "onUpdate:modelValue": ($event: any) => (__props.onToggleShowController(index, $event)),
                onChange: ($event: any) => (__props.onChange(index, $event))
              }, null, 8, ["model-value", "props", "inject-data", "onUpdate:modelValue", "onChange"]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {
            component: item,
            index: index
          })
        ])
      ], 2))
    }), 128))
  ]))
}
}

})